import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
// import axios from "axios";
import Search from "../../shared/Search";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";

import { toast } from "react-toastify";
import { useFormik } from "formik";
import { Inactive, Unmaped, Active } from "../../shared/ActivaInactive";
import axiosInstance from "../../config/axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const Firebase = () => {
  const [data, setData] = useState({});
  const [open1, setOpen1] = React.useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const [apikey, setapiKey] = useState("");
  const [domain, setauthDomain] = useState("");
  const [url, setdatabaseURL] = useState("");
  const [projectId, setprojectId] = useState("");
  const [bucket, setstorageBucket] = useState("");
  const [msgId, setmessagingSenderId] = useState("");
  const [appId, setappId] = useState("");
  const [measureId, setmeasurementId] = useState("");
  const [status, setStatus] = useState("");

  const editFunctionality = () => {
    console.log();
  };
  const handleModalClose = () => {
    handleClose1();
  };

  const Realtime = () => {
    axiosInstance
      .get(
        `api/admin/multivendor-realtime-sync-firebase-setup-key-setting`,

        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        //
        setData(response?.data?.vendor_razorpay_credentials);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    Realtime();
  }, []);

  const Realupdate = () => {
    const reqbody = new FormData();
    reqbody.append("apiKey", apikey);
    reqbody.append("authDomain", domain);
    reqbody.append("databaseURL", url);
    reqbody.append("projectId", projectId);
    reqbody.append("storageBucket", bucket);
    reqbody.append("messagingSenderId", msgId);
    reqbody.append("appId", appId);
    reqbody.append("measurementId", measureId);
    reqbody.append("status", status);
    axiosInstance
      .post(
        `api/admin/multivendor-realtime-sync-firebase-setup-key-setting/`,
        reqbody,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        },
      )
      .then((response) => {
        console.log(response?.data?.vendor_razorpay_credentials);
        handleClose1();
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    Realupdate();
  }, []);

  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            FireBase Real Time Sync
          </p>
        </div>{" "}
      </div>
      <TableContainer
        component={Paper}
        // sx={{  }}
        sx={{ width: "100%", maxHeight: 200 }}
        className="!text-black !mx-auto !bg-white overflow-auto px-2"
      >
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              <TableCell
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
                className="!text-center !text-gray-800 !font-bold"
              >
                ID
              </TableCell>
              <TableCell
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
                className="!text-center !text-gray-800 !font-bold"
              >
                Store
              </TableCell>
              <TableCell
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
                className="!text-center !text-gray-800 !font-bold"
              >
                ApiKey
              </TableCell>
              <TableCell
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
                className="!text-center !text-gray-800 !font-bold"
              >
                AuthDomain
              </TableCell>
              <TableCell
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
                className="!text-center !text-gray-800 !font-bold"
              >
                Database Url
              </TableCell>
              <TableCell
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
                className="!text-center !text-gray-800 !font-bold"
              >
                Project Id
              </TableCell>
              <TableCell
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
                className="!text-center !text-gray-800 !font-bold"
              >
                StorageBucket
              </TableCell>
              <TableCell
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
                className="!text-center !text-gray-800 !font-bold"
              >
                MessageSender Id
              </TableCell>
              <TableCell
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
                className="!text-center !text-gray-800 !font-bold"
              >
                App Id
              </TableCell>
              <TableCell
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
                className="!text-center !text-gray-800 !font-bold"
              >
                Measuring Id
              </TableCell>
              <TableCell
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
                className="!text-center !text-gray-800 !font-bold"
              >
                Status
              </TableCell>
              <TableCell
                style={{
                  fontFamily: "'Poppins', sans-serif",
                }}
                className="!text-center !text-gray-800 !font-bold"
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="!bg-red">
            <TableRow className="!text-slate-700">
              <TableCell
                className="!text-center !text-[12px]"
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                {data?.id}
              </TableCell>
              <TableCell
                className="!text-center !text-[12px]"
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                {data?.store?.store_name}
              </TableCell>
              <TableCell
                className="!text-center !text-[12px]"
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                {data?.apiKey}
              </TableCell>
              <TableCell
                className="!text-center !text-[12px]"
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                {data?.authDomain}
              </TableCell>
              <TableCell
                className="!text-center !text-[12px]"
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                {data?.databaseURL}
              </TableCell>
              <TableCell
                className="!text-center !text-[12px]"
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                {data?.projectId}
              </TableCell>
              <TableCell
                className="!text-center !text-[12px]"
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                {data?.storageBucket}
              </TableCell>
              <TableCell
                className="!text-center !text-[12px]"
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                {data?.messagingSenderId}
              </TableCell>
              <TableCell
                className="!text-center !text-[12px]"
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                {data?.appId}
              </TableCell>
              <TableCell
                className="!text-center !text-[12px]"
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                {data?.measurementId}
              </TableCell>
              <TableCell
                className="!text-center !text-[12px]"
                style={{
                  borderRight: "1px solid #D0D0D0",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                <div className="flex justify-center w-full p-4">
                  {data.status === null ? (
                    <Unmaped />
                  ) : data.status === true ? (
                    <Active />
                  ) : (
                    <Inactive />
                  )}
                </div>
              </TableCell>

              <TableCell
                className="!text-center !text-[12px]"
                style={{
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                <div>
                  <div onClick={handleOpen1}>
                    <BorderColorIcon
                      className="text-green-400"
                      onClick={() => editFunctionality()}
                    />
                  </div>
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <div
        className="!float-right relative bg-white w-[100%] mx-auto bottom-0 right-0 py-3 border-t-2 border-gray-400 !flex-col !justify-end !items-center"
        style={{ marginRight: "0px" }}
      ></div>
      <Modal
        open={open1}
        onClose={handleClose1}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style, width: 400 }} className="rounded-2xl !border-0">
          <div
            id="child-modal-title "
            className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
          ></div>
          <div className=" ">
            <p className="text-black"> FireBase Update Real Time Sync</p>
            <div className="flex gap-5">
              <TextField
                size="small"
                id="outlined-basic"
                label="Key"
                onChange={(event) => setapiKey(event.target.value)}
                variant="outlined"
                className="!w-[100%] !mt-3"
                value={apikey}
              />
              <TextField
                size="small"
                id="outlined-basic"
                label="url"
                onChange={(event) => setdatabaseURL(event.target.value)}
                variant="outlined"
                className="!w-[100%] !mt-3"
                value={url}
              />
            </div>
            <div className="flex gap-5">
              <TextField
                size="small"
                id="outlined-basic"
                label="Domain"
                variant="outlined"
                className="!w-[100%] !mt-3"
                value={domain}
                onChange={(event) => setauthDomain(event.target.value)}
              />

              <TextField
                size="small"
                id="outlined-basic"
                label="Status"
                variant="outlined"
                className="!w-[100%] !mt-3"
                value={status}
                onChange={(event) => setStatus(event.target.value)}
              />
            </div>
            <div className="flex gap-5">
              <TextField
                size="small"
                id="outlined-basic"
                label="Project Id"
                variant="outlined"
                className="!w-[100%] !mt-3"
                value={projectId}
                onChange={(event) => setprojectId(event.target.value)}
              />
              <TextField
                size="small"
                id="outlined-basic"
                label="bucket"
                variant="outlined"
                className="!w-[100%] !mt-3"
                value={bucket}
                onChange={(event) => setstorageBucket(event.target.value)}
              />
            </div>
            <div className="flex gap-5">
              <TextField
                size="small"
                id="outlined-basic"
                label="msgId"
                variant="outlined"
                className="!w-[100%] !mt-3"
                value={msgId}
                onChange={(event) => setmessagingSenderId(event.target.value)}
              />
              <TextField
                size="small"
                id="outlined-basic"
                label="appId"
                variant="outlined"
                className="!w-[100%] !mt-3"
                value={appId}
                onChange={(event) => setappId(event.target.value)}
              />
            </div>
            <TextField
              size="small"
              id="outlined-basic"
              label="Measure"
              variant="outlined"
              className="!w-[100%] !mt-3"
              value={measureId}
              onChange={(event) => setmeasurementId(event.target.value)}
            />
          </div>
          <Button
            onClick={handleModalClose}
            variant="contained"
            color="warning"
            className="!py-2 !mt-3"
          >
            CANCEL
          </Button>
          <Button
            variant="contained"
            type="submit"
            color="success"
            className="!py-2 !px-5 !font-bold !mt-3 !float-right"
            onClick={Realupdate}
          >
            Update
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default Firebase;
